module.exports = __webpack_public_path__ + "static/media/baloon1.7940925e.png";